import { api, 
  getWithOptionalAuthorization, 
  putWithOptionalAuthorization, 
  postWithOptionalAuthorization,
  deleteWithOptionalAuthorization,
  patchWithOptionalAuthorization } from './api';
import { GEOFENCE_NOTIFICATION_BASE } from './apiConstant';
import { getToken } from './auth';
import { decryptMessage } from '../utils/decrypt';

export interface GeoFencePostBody {
  campaignName: string;
  status: number;
  startDate: string | null;
  startTime: string | null;
  endDate: string | null;
  endTime: string | null;
  centreCoordinate: string[];
  //markerPoint: string | null;
  isNavigation: boolean;
  inAppNotification: boolean;
  pushNotification: boolean;
  emailNotification: boolean;
  locationAddress: string;
  km: number;
  mile: number;
  title: string;
  subTitle: string;
  subjectLine: string;
  emailText: string;
  description: string;
  timeZone: string;
}

export type GeofenceNotificationImageParams = {
    GeofenceAnnouncementSupportID?: string;
    GeofenceAnnouncementFile: File;
};

export interface GeofenceNotificationUpdateParams {
  id: string;
  campaignName: string;
  status: number;
  startDate: string | null;
  startTime: string | null;
  endDate: string | null;
  endTime: string | null;
  centreCoordinate: string[];
  //markerPoint: string | null;
  isNavigation: boolean;
  inAppNotification: boolean;
  pushNotification: boolean;
  emailNotification: boolean;
  locationAddress: string;
  km: number;
  mile: number;
  title: string;
  subTitle: string;
  subjectLine: string;
  emailText: string;
  description: string;
  timeZone: string;
  geofenceAnnouncementImagesIDs?: string[];
}

export interface GeofenceNotificationDetailsParams {
  id: string;
  campaignName: string;
  status: number;
  startDate: string | null;
  startTime: string | null;
  endDate: string | null;
  endTime: string | null;
  centreCoordinate: string[];
  //markerPoint: string | null;
  isNavigation: boolean;
  inAppNotification: boolean;
  pushNotification: boolean;
  emailNotification: boolean;
  locationAddress: string;
  km: number;
  mile: number;
  title: string;
  subTitle: string;
  subjectLine: string;
  emailText: string;
  description: string;
  geofenceAnnouncementImageResponses?: GeofenceAnnouncementImageResponse[];
}

export interface GeofenceAnnouncementImageResponse {
  id: string;
  geofenceAnnouncementSupportID: string;
  fileName: string;
  fileUrl: string;
  createdAt: string;
}

export type GeofenceNotificationDescriptionPatchBody = {
    id: string;
    description: string;
};

const getGeofenceNotificationImageUploadFormData = (params: GeofenceNotificationImageParams): FormData => {

  const formData = new FormData();
  if (params.GeofenceAnnouncementSupportID !== undefined) {
    formData.append('GeofenceAnnouncementSupportID', params.GeofenceAnnouncementSupportID);
  }
  formData.append('GeofenceAnnouncementFile', params.GeofenceAnnouncementFile);
  return formData;
};

const geofenceNotificationApi = {

  getGeofenceNotificationByStatusId : async (statusId: number ): Promise<any> => {
    try {
      const encryptedGeofenceResponse = await getWithOptionalAuthorization(`${GEOFENCE_NOTIFICATION_BASE}?Status=${statusId}`, true);
      const geofenceGetResponse =  decryptMessage(encryptedGeofenceResponse.data.Data, getToken());
      return geofenceGetResponse;
    } catch (error) {
      console.error('Error fetching get geofence:', error);
      throw error;
    }
  },

  getGeofenceNotificationById : async (id: string ): Promise<any> => {
    try {
      
      const encryptedGeofenceResponse = await getWithOptionalAuthorization(`${GEOFENCE_NOTIFICATION_BASE}/${id}`, true);
      const geofenceGetResponse =  decryptMessage(encryptedGeofenceResponse.data.Data, getToken());
      return geofenceGetResponse;
    } catch (error) {
      console.error('Error fetching get geofence:', error);
      throw error;
    }
  },

  postGeofenceNotification: async (body: GeoFencePostBody) => {
    const encryptedGeofenceResponse = await postWithOptionalAuthorization(`${GEOFENCE_NOTIFICATION_BASE}`, body, true);
    const geofencePostResponse = decryptMessage(encryptedGeofenceResponse.data.Data, getToken());
    return geofencePostResponse;
  },

  postGeofenceNotificationImageUpload: async (params: GeofenceNotificationImageParams) => {
  
      const body = getGeofenceNotificationImageUploadFormData(params);
      const encryptedGeofenceImageUploadResponse = await postWithOptionalAuthorization(`${GEOFENCE_NOTIFICATION_BASE}/GeoFenceAnnouncementSupportImages`, body, true, true);
      const geofenceImageUploadPostResponse = decryptMessage(encryptedGeofenceImageUploadResponse.data.Data, getToken());
      return geofenceImageUploadPostResponse;
  },

  putGeofenceNotification: async (params: GeofenceNotificationUpdateParams) => {
    const response = await putWithOptionalAuthorization(`${GEOFENCE_NOTIFICATION_BASE}`, params, true);
    return response;
  },

  deleteGeofenceNotification: async (ID: string) => {
    const response = await deleteWithOptionalAuthorization(`${GEOFENCE_NOTIFICATION_BASE}/${ID}`, true);
    return response;
  },

  patchGeofenceNotificationDescription: async (body: GeofenceNotificationDescriptionPatchBody) => {
    const response = await patchWithOptionalAuthorization(`${GEOFENCE_NOTIFICATION_BASE}/Description`, body, true);
    return response;
  }
};

export default geofenceNotificationApi;